import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type SidebarView = 'MAIN' | 'SETTINGS';

export type SidebarState = {
  currentView: SidebarView;
};

export const sidebarInitialState: SidebarState = {
  currentView: 'MAIN',
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState: sidebarInitialState,
  reducers: {
    setSidebarView(state, action: PayloadAction<SidebarView>) {
      state.currentView = action.payload;
    },
  },
});

export const { setSidebarView } = sidebarSlice.actions;
export default sidebarSlice.reducer;
